<template>
  <div class="newLogin">
    <template>
      <!-- 主要视图开始 -->
      <div class="content_login">
        <div class="left">
          <img :src="logoPng" />
        </div>
        <div class="right">
          <!-- 右上角图标切换 -->
          <div class="wechatQr" v-if="HAVE_PHONE && VUE_PLATFORM_TYPE !== 'independent' && HAVE_QRCODE" @click="showDefaultAttr = !showDefaultAttr;showImg = ! showImg">
            <img src="./assets/images/login_QR code.jpg" v-if="showImg" :key="1"  @click="delu">
            <img src="./assets/images/login_message.png" v-else :key="2" @click="delu">
          </div>
          <h2 :style="haveRegister?'':'margin-top:40px'">欢迎登录</h2>
          <p>WELCOME TO LOGIN</p>
          <!-- 密码登录和短信登录切换 -->
          <div class="right_form" v-if="showDefaultAttr" :key="1">
            <!-- 独立部署没有手机号 -->
            <el-tabs v-model="activeName" @tab-click="handleClick" v-if="HAVE_PHONE">
              <el-tab-pane label="密码登录" name="first">
                  <el-form @submit.native.prevent :model="form" ref="form" label-width="100px" class="password_login" :rules="rules">
                      <el-form-item prop="email">
                        <el-input v-model="form.email" @keydown.enter.native="verification('form')" placeholder="请输入邮箱或手机号" maxlength="35">
                          <i slot="prefix" class="verify_i">
                            <img src="./assets/images/login_number.png"/>
                          </i>
                        </el-input>
                      </el-form-item>
                      <el-form-item prop="password">
                        <el-input v-model="form.password" @keydown.enter.native="verification('form')" type="password" class="input_bottom" placeholder="请输入密码">
                          <i slot="prefix" class="verify_i">
                            <img src="./assets/images/login_password.png" />
                          </i>
                        </el-input>
                      </el-form-item>
                       <el-form-item prop="validcode">
                          <el-input v-model="form.validcode" maxlength="4" @keydown.enter.native="verification('form')" placeholder="请输入验证码" style="width:150px;">
                            <i slot="prefix" class="verify_i">
                              <img src="./assets/images/login_Verification.png" />
                            </i>
                          </el-input>
                          <ValidCode @input="createValidCode" ref="ValidCode"/>
                        </el-form-item>
                      <el-form-item class="login_button" :class="{'mb18':!haveRegister}">
                        <el-button class="login_submit" type="primary" @click="verification('form')">登录</el-button>
                      </el-form-item>
                  </el-form>
              </el-tab-pane>
              <el-tab-pane label="短信登录" name="last">
                <el-form @submit.native.prevent :model="formMessage" ref="formMessage" label-width="100px" class="message_login" :rules="rules">
                      <el-form-item prop="phone">
                        <el-input v-model="formMessage.phone" @keydown.enter.native="submitForm('formMessage')" placeholder="请输入手机号">
                          <i slot="prefix" class="verify_i">
                            <img src="./assets/images/login_number.png"/>
                          </i>
                        </el-input>
                      </el-form-item>
                       <el-form-item prop="authcode">
                          <el-input v-model="formMessage.authcode" autocomplete="off" maxlength="6" @keydown.enter.native="submitForm('formMessage')" placeholder="请输入验证码" style="width:150px;">
                            <i slot="prefix" class="verify_i">
                              <img src="./assets/images/login_Verification.png" />
                            </i>
                          </el-input>
                          <el-button class="sendcode"  @click="getVerificationCode('ruleFormPhone')" :disabled="disabledPhone">{{verificationCodePhone}}
                            <span v-if="verPhone">秒后重试</span>
                          </el-button>
                        </el-form-item>
                      <el-form-item class="login_button" :class="{'mb18':!haveRegister}">
                        <el-button class="login_submit" type="primary" @click="submitForm('formMessage')">登录</el-button>
                      </el-form-item>
                      <div class="login_alert" v-if="haveRegister">
                        <p>未注册用户手机号验证成功后自动注册并登录</p>
                        <p>注册即代表我已阅读并同意<a class="text-blure" :href="SERVE_URL" target="_blank"> 服务条款</a></p>
                      </div>
                  </el-form>
              </el-tab-pane>
            </el-tabs>
            <div style="margin-top: 30px;" v-else>
              <el-form @submit.native.prevent :model="form" ref="form" label-width="100px" class="password_login" :rules="rules">
                <el-form-item prop="email">
                  <el-input v-model="form.email" @keydown.enter.native="verification('form')" placeholder="请输入邮箱或手机号" maxlength="35">
                    <i slot="prefix" class="verify_i">
                      <img src="./assets/images/login_number.png"/>
                    </i>
                  </el-input>
                </el-form-item>
                <el-form-item prop="password">
                  <el-input v-model="form.password" @keydown.enter.native="verification('form')" type="password" class="input_bottom" placeholder="请输入密码">
                    <i slot="prefix" class="verify_i">
                      <img src="./assets/images/login_password.png" />
                    </i>
                  </el-input>
                </el-form-item>
                <el-form-item prop="validcode">
                  <el-input v-model="form.validcode" maxlength="4" @keydown.enter.native="verification('form')" placeholder="请输入验证码" style="width:150px;">
                    <i slot="prefix" class="verify_i">
                      <img src="./assets/images/login_Verification.png" />
                    </i>
                  </el-input>
                  <ValidCode @input="createValidCode" ref="ValidCode"/>
                </el-form-item>
                <el-form-item class="login_button">
                  <el-button class="login_submit" type="primary" @click="verification('form')">登录</el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
          <!-- 微信登录 -->
          <div class="right_form" v-else :key="2">
             <div class="wechat_login" v-show="isShow">
               <img :src="'data:image/png;base64,' + wxImgSrc" alt="微信二维码">
               <span v-show="loadingIcon"><i class="el-icon-loading"></i>&nbsp;登录中</span>
               <div class="upBox" v-if="wxUp" @click="wxRefresh">
                 <img src="./assets/images/refresh.png">
               </div>
             </div>
             <div class="login_alert">
                  <p style="color:#333333;">请使用微信“<span style="text-decoration: none;">扫一扫</span>”扫描二维码进行登录</p>
             </div>
          </div>
          <!-- 底部跳转 -->
          <div class="button_bottom" :class="{'pt18':!haveRegister}">
            <span @click="goRegister()"  v-if="haveRegister">注册</span>
            <span @click="goPassword()">忘记密码？</span>
          </div>
        </div>
      </div>
      <!-- 主要视图结束 -->
    </template>
  </div>
</template>

<script>
import md5 from "js-md5";

import { checkImgExists } from "@/utils/index";

import { createNamespacedHelpers } from "vuex";

const { mapActions } = createNamespacedHelpers("ws");

// 引入密码登录和短信登陆接口
import { userLoginAjax, loginPhoneCode ,loginPhone} from "@/services/loginRegister";

// 引入点击显示不同验证码组件
import ValidCode from '@/components/ValidCode';

// //输入框不为空
// window.onkeypress = (event) => {
//   if (event.keyCode == 32) event.returnValue = false
// }
export default {
  name: "newLogin",
  components: {ValidCode},
  data() {
    // 验证密码登录的邮箱地址或手机号input框
    let validateEmail = (rule, value, callback) => {
      let email = /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      // let phone = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
      let phone = /^(?:(?:\+|00)86)?1\d{10}$/;
      // 独立部署只验证邮箱
      // if (!this.HAVE_PHONE) {
      //   if (value === "") {
      //     return callback(new Error('请输入邮箱地址'));
      //   }
      //   else if(!email.test(value)) {
      //     return callback(new Error('请输入正确的邮箱地址'));
      //   }
      // } else {
      //   if (value === "") {
      //     return callback(new Error('请输入邮箱地址或手机号'));
      //   }
      //   else if(!email.test(value)&&!phone.test(value)) {
      //     return callback(new Error('请输入正确的邮箱地址或手机号'));
      //   }
      // }
      if (value === "") {
        return callback(new Error('请输入邮箱地址或手机号'));
      }
      else if(!email.test(value)&&!phone.test(value)) {
        return callback(new Error('请输入正确的邮箱地址或手机号'));
      }
      callback();
    };
    // 验证密码登录的密码input框
    let validatePass = (rule, value, callback) => {
      let password = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z_]{6,16}$/g;
      if (value === "") {
        return callback(new Error('请输入密码'));
      }
      // else if (!password.test(value)) {
      //   // return callback(new Error('请输入6-16位包含数字和字母的密码'));
      //   return callback(new Error('请输入正确的账号密码'));
      // }
      callback();
    };
    // 验证密码登录的验证码input框
    let validateCode = (rule, value, callback) => {
      if (value === "") {
        return callback(new Error('请输入验证码'));
      }else if(value!==this.validCode){
        return callback(new Error('验证码错误'))
      }
      callback();
    };
    // 验证短信登录的手机号input框
    let validatePhone = (rule, value, callback) => {
      // let phone = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
      let phone = /^(?:(?:\+|00)86)?1\d{10}$/;
      if (value === "") {
        return callback(new Error('请输入手机号'));
      }
      else if(!phone.test(value)) {
        return callback(new Error('请输入正确的手机号'));
      }
      callback();
    };
    // 验证短信登录的验证码input框
    var verify = (rule, value, callback) => {
       if (value === "") {
        return callback(new Error('请输入验证码'));
      }
      callback();
    };
    return {
      // 被激活页签
      activeName: "first",
      // 密码登录短信登陆或者扫码登录
      showDefaultAttr: true,
      // 密码登录短信登陆或者扫码登录图片更换
      showImg: true,
      // 短信登陆
      disabledPhone: false,
      verPhone: false,
      SERVE_URL: 'https://gen.fycat.com/h5/serveClause.html',
      // 微信登录
      isShow: true,
      // appid: "",
      wxImgSrc: "",
      wxState: "",
      // 设置定时器
      wxInter: null,
      loadingIcon: false,
      wxUp: false,
      form: {
        email: "",
        password: "",
        validcode: ""
      },
      formMessage: {
        phone: "",
        authcode: ""
      },
      verificationCodePhone: '发送验证码',
      rules: {
        email: [{ required: true, validator: validateEmail, trigger: "blur" }],
        password: [{ required: true,validator: validatePass, trigger: "blur" }],
        validcode: [{ required: true, validator: validateCode, trigger: "blur" }],
        phone: [{ required: true, validator: validatePhone, trigger: "blur" }],
        authcode: [{ required: true, validator: verify, trigger: 'blur' }]
      },
      logoPng: require('./assets/images/login_left.png'),
      VUE_PLATFORM_TYPE: VUE_PLATFORM_TYPE,
      haveRegister: !!HAVE_REGISTER,
    };
  },
  destroyed(){
    clearInterval(this.wxInter);// 清除定时器
    this.wxInter = null;
  },
  mounted() {
    this.logoChange();
  },
  computed:{
    HAVE_PHONE(){
      return HAVE_PHONE;
    },
    HAVE_QRCODE() {
      return HAVE_QRCODE;
    }
  },
  beforeDestroy() {
    clearInterval(this.wxInter);
  },
  methods: {
     //websocket
    ...mapActions(["UPDATE_LOGIN_INFO"]),
    logoChange () {
      switch (this.VUE_PLATFORM_TYPE) {
        case 'demo':
          if (localStorage.myLoginSloganPic && localStorage.myLoginSloganPic !== 'null') {
            checkImgExists(localStorage.myLoginSloganPic).then(()=>{
              this.logoPng = localStorage.myLoginSloganPic;
            }).catch(()=>{
              this.logoPng = require('./assets/images/login_left.png');
            })
          } else {
            this.logoPng = require('./assets/images/login_left.png');
          }
          break;
        default:
          this.logoPng = require('./assets/images/login_left.png');
          break;
      }
    },
    // 密码登录验证码
    createValidCode (data) {
      this.validCode = data;
    },
    // 密码登录
    verification(form) {
      const self = this;
      self.$refs[form].validate(async valid => {
        if (valid) {
          let params = Object();
          Reflect.set(params, "loginName", self.form.email);
          Reflect.set(params, "password", md5(self.form.password));
          Reflect.set(params, "host", window.location.host);
          self.$message.closeAll();
          const resp = await userLoginAjax(params);
          if (resp.status === 200 && resp.success) {
            let result = resp.result;
            localStorage.setItem("userInfo", JSON.stringify(result));
            localStorage.setItem("myUser", JSON.stringify(result));
            self.setCompanyCode(result);
            self.UPDATE_LOGIN_INFO(result);
            self.$nextTick(() => {
              self.$router.push({ name: "homeMiddleware" }); // 跳到首页
            })
          } else {
            self.$refs.ValidCode.refreshCode();
          }
        }
      });
    },
    // 短信登录
    submitForm(formMessage) {
      const self = this;
      self.$refs[formMessage].validate(async valid => {
        if (valid) {
          let params = Object();
          Reflect.set(params, "loginPhone", self.formMessage.phone);
          Reflect.set(params, "verificationCode", self.formMessage.authcode);
          Reflect.set(params, "host", window.location.host);
          self.$message.closeAll();
          if(this.haveRegister){ //有注册
            const resp = await loginPhoneCode(params);
            if (resp.status === 200 && resp.success) {
              let result = resp.result;
              self.setCompanyCode(result);
              self.UPDATE_LOGIN_INFO(result);
              self.$nextTick(() => {
              self.$router.push({ name: "homeMiddleware" }); // 跳到首页
              })
            }
          }else{ //没有注册
            const resp = await loginPhone(params);
            if (resp.status === 200 && resp.success) {
              let result = resp.result;
              self.setCompanyCode(result);
              self.UPDATE_LOGIN_INFO(result);
              self.$nextTick(() => {
              self.$router.push({ name: "homeMiddleware" }); // 跳到首页
              })
            }
          }
        }
      })
    },
    // 获取短信登录验证码
    getVerificationCode() {
      let loginPhone = true;
      this.$refs.formMessage.validateField(["phone"], errTip => {
        if (errTip) {
          // 会调用很多次
          loginPhone = false;
        }
      });
      if (loginPhone) {
        this.verPhone = true;
        let timeCounter;
        this.disabledPhone = true;
        this.verificationCodePhone = 60;
        if (this.verificationCodePhone < 0) {
          clearTimeout(timeCounter);
          this.disabledPhone = false;
          this.verPhone = false;
          this.verificationCodePhone = "发送验证码";
        }
        timeCounter = setInterval (() => {
          this.verificationCodePhone--;
          if (this.verificationCodePhone < 0) {
            clearTimeout(timeCounter);
            this.disabledPhone = false;
            this.verPhone = false;
            this.verificationCodePhone = "发送验证码";
          }
        },1000);
        let params = {
          loginPhone : this.formMessage.phone
        };
        this.catReq1Service("/user/send_verifyCode",params)
        .then(response => {
          if (!response.success) {
            this.disabledPhone = false;
            this.verificationCodePhone = "发送验证码";
            clearTimeout(timeCounter);
            this.verPhone=false;
            return;
          }
        })
      }
    },
    // 刷新页面
    wxRefresh () {
      this.getWX();
      this.wxUp = false;
    },
    // 判断用户是否关联手机号
    // getUser () {
    //   let myPhone = localStorage.getItem("myPhone");
    //   let myEmail = localStorage.getItem("myEmail");
    //   this.loadingIcon = false;
    //   if (myPhone !== "" || myEmail !== "") {
    //     this.$router.replace({ name: "homeMiddleware" }); // 跳到首页
    //   } else {
    //     // this.$router.replace({ name: "newLogin" });
    //   }
    // },
    // 二维码登录
    wxLogin (data) {
      localStorage.setItem("openid", data);
      let self = this;
      this.loadingIcon = true;
      this.catReq1Service("/user/loginByOpenId", { openId: data }).then(
        function (response) {
          if (!response.success) {
            return;
          }
          var data = response.result;
          var val = JSON.stringify(data);
          localStorage.setItem("myUser", val);
          if(response.resultCode === "1") {
            let result = response.result;
            localStorage.setItem("userInfo", JSON.stringify(result));
            localStorage.setItem("myUser", JSON.stringify(result));
            self.setCompanyCode(result);
            self.UPDATE_LOGIN_INFO(result);
            self.$nextTick(() => {
              self.$router.push({ name: "homeMiddleware" }); // 跳到首页
            })
          }
        }
      )
    },
    // 轮询 是否扫二维码
    getWXStatus () {
      var that = this;
      this.catReq1Service(
        "/wechat/get_openId",
        {state: this.wxState},
        "post",
        2
      ).then(function (response) {
        if (response.resultCode == "0") {
          that.wxUp = true;
          clearInterval(that.wxInter);
          return;
        }
        let data = response.result;
        if (data != null) {
          if (data.resultCode === "0") {
            clearInterval(that.wxInter);
            if(data.errorDesc === "用户无权登录") {
              that.$message.closeAll();
              that.$message({
                message: "暂无登录权限，请联系管理员。或飞译官方客服：13717630007",
                type: "warning"
              });
              that.getWX();
              return;
            }
            that.wxUp = true;
          } else {
            clearInterval(that.wxInter);
            that.wxLogin(data.result.openId);
          }
        }
      })
    },
    // 获取二维码
    getWX () {
      clearInterval(this.wxInter);
      let that = this;
      this.isShow = true;
      this.catReq1Service("/wechat/get_wechat_login_url").then(function (
        response
      ) {
        if (!response.success) {
          return;
        }
        that.wxImgSrc = response.result.urlBase64;
        that.wxState = response.result.state;
        that.wxInter = window.setInterval(that.getWXStatus, 1000);
      })
    },
    // 微信扫码
    setWx () {
      this.isShow = true;
    },
    // 右上角控制二维码轮播
    delu () {
      if (this.showImg) {
        this.getWX();
        this.resetForm();
      } else {
        clearInterval(this.wxInter);
      }
    },
    // 储存平台编码
    setCompanyCode (userInfo) {
      let companyCode = localStorage.getItem('companyCode');
      let hasCompany = false;
      if (companyCode && companyCode !== 'null') {
        userInfo.companyList.forEach(company => {
          if (company.code === companyCode) {
            hasCompany = true;
          }
        })
      }
      if (!companyCode || companyCode === 'null' || !hasCompany) {
        if (userInfo.lastSelectCompany) {
          companyCode = userInfo.lastSelectCompany.code;
        } else if (userInfo.majorCompanyCode) {
          companyCode = userInfo.majorCompanyCode;
        } else if (userInfo.seltCompany) {
          companyCode = userInfo.seltCompany.code;
        } else if (userInfo.companyList && userInfo.companyList.length) {
          companyCode = userInfo.companyList[0].code;
        }
      }
      if (companyCode) {
        localStorage.setItem("myCompanyCode", companyCode)
        localStorage.setItem("companyCode", companyCode)
      }
    },
    // 密码登录或者短信登录
    handleClick(tab) {
      this.activeName = tab._props.name;
      this.resetForm();
    },
    // 清空表单数据
    resetForm() {
      this.form.email = '';
      this.form.password = '';
      this.form.validcode= '';
      this.formMessage.phone = '';
      this.formMessage.authcode = '';
      this.$refs["form"].clearValidate();
      this.$refs["formMessage"].clearValidate();
    },
    //跳转注册
    goRegister() {
      if (this.$route.query.key !== undefined) {
        this.$router.push({
          path: "/login/registration",
          query: {
            key: this.$route.query.key,
          },
        });
      } else {
        this.$router.push("/login/registration");
      }
    },
    //跳转重置密码
    goPassword() {
      this.$router.push("/login/retrievePassword");
    }
  }
};
</script>
<style lang="less" scoped>
@import "./assets/style.less";
</style>
<style lang="less">
.mb18{
  margin-bottom: 18px;
}
.pt18{
  padding-top: 18px !important;
}
</style>
